import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {I18nModule, UrlModule} from '@spartacus/core';
import {NgSelectModule} from '@ng-select/ng-select';
import {GroupSkipDirective} from '@dcp/accessibility';
import {MessageModule, ModalModule} from 'ng-design-system';
import {
  ConfiguratorConflictDescriptionModule,
  ConfiguratorGroupModule,
} from '@spartacus/product-configurator/rulebased';
import {RouterModule} from '@angular/router';
import {DisableLoadingFormModule} from '../disable-loading-form/disable-loading-form.module';
import {DcpConfiguratorSinglePageFormComponent} from './dcp-configurator-single-page-form.component';
import {DcpConfiguratorHeaderMessagesComponent} from '../dcp-configurator-header-messages/dcp-configurator-header-messages.component';
import {LoadingPageModule} from '../shared/loading-page/loading-page.module';
import {ContactUsButtonModule} from '../shared/contact-us-button/contact-us-button.module';
import {ContactUsLinkModule} from '../shared/contact-us-link/contact-us-link.module';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    NgSelectModule,
    MessageModule,
    ModalModule,
    ConfiguratorConflictDescriptionModule,
    UrlModule,
    RouterModule,
    DisableLoadingFormModule,
    ConfiguratorGroupModule,
    LoadingPageModule,
    ContactUsButtonModule,
    ContactUsLinkModule,
    GroupSkipDirective,
  ],
  declarations: [DcpConfiguratorSinglePageFormComponent, DcpConfiguratorHeaderMessagesComponent],
  exports: [DcpConfiguratorSinglePageFormComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DcpConfiguratorSinglePageFormModule {}
